<template>
<div class="wrap">
  <error-tip v-if="errorShow" :show="errorShow" :info="errorInfo"></error-tip>
  <div class="todobox">
    <div class="todo_dialog_share" v-bind:style="styleObject" v-if="!isShare">
      <h3>分享清单</h3>
      <div class="url">
        <button @click.prevent='handleCopy()'>复制连接</button>
        <i @click="handleShowQrcode()" >&#xe904;</i>
        <input type="text" :value="comShareUrl" id="share_url" />
      </div>
      <div class="qrcode" v-bind:style="styleQrcodeObject">
        <img :src="qrcode" />
      </div>
    </div>
    <div class="todo_dialog_share" style="width:248px; margin-left: 200px; padding:0; height: auto;" v-bind:style="styleObject" v-if="isShare">
      <img :src="qrcode" />
    </div>
    <div class="todo_sidebar">
      <a href="#" @click.prevent="handleShowQrcodeDialog()">
        <i>&#xe903;</i>
        <span>分享</span>
      </a>
      <a href="#" class="create" @click.prevent="redirectToHuoban()" v-if="hasCreate">
        <i>&#xe902;</i>
        <span>新建</span>
      </a>
    </div>
    <div class="todo_form">
      <div class="todo_create" v-if="showCreateList">
        <a href="#" @click.prevent="redirectToHuoban()"><span>新建一个清单</span><i>&#xe905;</i></a>
      </div>
      <div class="todo_create" v-if="showClientShare">
        <a href="#" @click.prevent="openClientShare()"><span>分享清单</span></a>
      </div>
      <div class="todo_title">
        <todo-title :text.sync="comTitle" @title-box-change="handleTitleChange"></todo-title>
      </div>
      <div class="todo_list">
        <todo-list></todo-list>
      </div>
    </div>
    <div class="todo_foot">
      <p><a href="#">©云表格·极简清单</a></p>
    </div>
    <div v-if="showMask" @click="closeMask()">
      <div class="wechat_tips"><span>分享清单给好友</span></div>
      <div class="mask"></div>
    </div>
  </div>
</div>
</template>

<script>
import { getConfigInfo, getTodos, errorShowAction, updateConfigInfo, weChatAjax, wxConfig, wxReady, onMenuShareAppMessage, onMenuShareTimeline, setDocTitle } from 'src/vuex/actions'
import TodoList from 'components/todo-list'
import TodoTitle from 'components/todo-title'
import ErrorTip from 'components/error-tip'
import _ from 'lodash'
export default {
  name: 'todo-home',
  components: {
    TodoList,
    TodoTitle,
    ErrorTip
  },

  data() {
    let isWeChat = navigator.userAgent.indexOf('MicroMessenger') > 0
    let isShare = this.$route.name === 'share'
    return {
      qrcode: '',
      isShowDialog: false,
      hasCreate: false,
      isShowQrcode: false,
      showMask: false,
      isMobile: window.HuobanAppSDK.isMobile,
      isPC: window.HuobanAppSDK.isPC,
      isWeChat: isWeChat,
      isShare: isShare,
      showCreateList: !window.HuobanAppSDK.isClient && window.HuobanAppSDK.isMobile && isShare,
      showClientShare: false //获取配置信息后才能显示分享按钮
    }
  },

  vuex: {
    getters: {
      // table: state => state.auth.table,
      configInfo: state => state.todo.configInfo,
      isLoading: state => state.todo.isLoading,
      errorShow: state => state.todo.errorShow,
      errorInfo: state => state.todo.errorInfo,
      todoList: state => state.todo.todoList
    },
    actions: {
      getConfigInfo,
      getTodos,
      errorShowAction,
      updateConfigInfo,
      setDocTitle
    }
  },

  route: {
    data(transition) {
      this.getConfigInfo().then(res => {
        let isWeChat = navigator.userAgent.indexOf('MicroMessenger') > 0
        let isShare = this.$route.name === 'share'
        if (window.HuobanAppSDK.isClient || (isWeChat && !isShare)) {
          this.showClientShare = true
        }
        if (res && res.title) {
          this.setDocTitle(res.title)
          if (this.isWeChat) {

            if (this.isShare) {
              this.setInShare(res)
            } else {
              this.setInClient(res)
            }
          }
        }
      })
      transition.next()
    }
  },

  ready() {
    this.client = window.HuobanAppSDK.client()
    if (this.isPC && document.body.className === '') {
      document.body.className = document.body.className + 'isPC'
    }
    if (this.isMobile && document.body.className === '') {
      document.body.className = document.body.className + 'isMobile'
    }
    if (this.isShare) {
      this.hasCreate = true
    }
  },

  computed: {
    comTitle() {
      return this.configInfo.title
    },
    comShareUrl() {
      return this.configInfo.url
    },
    styleObject() {
      let ret = {}
      if (this.isShowDialog) {
        ret.display = 'block'
      }
      return ret
    },
    styleQrcodeObject() {
      let ret = {}
      if (this.isShowQrcode) {
        ret.display = 'block'
      }
      return ret
    }
  },

  methods: {

    setInShare(res) {
      weChatAjax().then(resq => {
        if (resq) {
          wxConfig(resq.data)
          wxReady(() => {
            let title = res.title
            let url = res.url
            if (!_.isEmpty(this.todoList)) {
              let content = this.todoList[0].todo_content
              onMenuShareAppMessage(title, url, content)
              onMenuShareTimeline(url, content)
            } else {
              this.getTodos().then((result) => {
                if (!_.isEmpty(result)) {
                  let content = result[0].todo_content
                  onMenuShareAppMessage(title, url, content)
                  onMenuShareTimeline(url, content)
                } else {
                  let content = '极简清单';
                  onMenuShareAppMessage(title, url, content)
                  onMenuShareTimeline(url, content)
                }
              })
            }
          })
        }
      })
    },

    setInClient(res) {
      this.getTodos().then((result) => {
        this.client.openShare({
          title: this.comTitle,
          content: this.todoList.length ? this.todoList[0].todo_content : '极简清单',
          image: 'https://oaaqymp5v.qnssl.com/todo/152icon.png',
          url: this.comShareUrl
        }, (data, error) => {
          this.closeMask()
        })
      })
    },

    closeMask() {
      this.showMask = false;
    },

    openClientShare() {
      if (this.isWeChat && !this.isShare) {
        // this.client.openWebPage(this.comShareUrl)
        this.showMask = true;
        this.client.openShare({
          title: this.comTitle,
          content: this.todoList.length ? this.todoList[0].todo_content : '极简清单',
          image: 'https://oaaqymp5v.qnssl.com/todo/152icon.png',
          url: this.comShareUrl
        }, (data, error) => {
          this.closeMask()
        })
      } else {
        this.client.openShare({
          title: this.comTitle,
          content: this.todoList.length ? this.todoList[0].todo_content : '极简清单',
          image: 'https://oaaqymp5v.qnssl.com/todo/152icon.png',
          url: this.comShareUrl
        })
      }
    },

    handleShowQrcodeDialog() {
      if (!this.configInfo) {
        return
      }
      if (this.isShowDialog) {
        this.isShowDialog = false
        this.isShowQrcode = false
      } else {
        this.isShowDialog = true
        this.qrcode = this.client.generateQrcode(this.configInfo.url)
      }
    },

    handleShowQrcode() {
      if (this.qrcode) {
        if (this.isShowQrcode) {
          this.isShowQrcode = false
        } else {
          this.isShowQrcode = true
        }
      }
    },

    handleCopy() {
      document.getElementById('share_url').select()
      document.execCommand('Copy')
    },

    redirectToHuoban() {
      let url = 'https://m.huoban.com/preinstall?preInsA10Id=11007'
      location.href = url
    },

    handleTitleChange(text) {
      if (text) {
        let param = {
          title: text
        }
        this.updateConfigInfo(param)
      }
    }
  },

  beforeDestroy() {
  }
}
</script>



/** WEBPACK FOOTER **
 ** home.vue?49115917
 **/